import { useMutation } from '@tanstack/react-query'
import {resetPassword} from "@/api/gateway"
import { PostParam } from '@/types'

export function useResetPassword(props?: PostParam) {
    const { onSuccess, onError } = props || {};

    return useMutation({
        mutationFn: resetPassword,
        onSuccess,
        onError
    })
}